<!-- 企业级-业务领域-会议室预约-配置 -->
<template>
  <div class="mainArea CConferenceConfig">
    
    <el-button type="primary" class="mb20 mt20" @click="openAdd">新建会议室预约</el-button>
    <div class="tabList">
      <el-table :data="configList" style="width: 100%" v-loading="tableLoading">
        <el-table-column type="index" label="序号" width="100"></el-table-column>
        <el-table-column prop="audit_name" label="会议室名称"></el-table-column>
        <el-table-column prop="user_name" label="审批人"></el-table-column>
        <el-table-column label="包含设备">
          <template slot-scope="scope">
            <el-button type="text" @click="getAccessDevice(scope.row.device_info)">查看</el-button>
          </template>
        </el-table-column>
        <el-table-column label="预约二维码">
          <template slot-scope="scope">
            <el-button type="text" @click="previewImg(scope.row.id)">查看</el-button>
          </template>
        </el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button type="text" @click="openEdit(scope.$index)">修改</el-button>
            <el-button type="text" @click="openStatus(scope.row.id)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="paging" v-if="total>page">
      <el-pagination
        @current-change="CurrentChange"
        :current-page.sync="curr"
        :page-size="page"
        layout="prev, pager, next, jumper"
        :total="total">
      </el-pagination>
    </div>

    <!--新建弹窗-->
    <el-dialog title="新建会议室预约" :visible.sync="addDio" width="700px" class="configDio accessDio" center>
      <!-- <el-steps :active="addform.addStep" simple>
        <el-step title="1、编辑名称"></el-step>
        <el-step title="2、选择设备"></el-step>
        <el-step title="3、设置审批"></el-step>
      </el-steps> -->
      <div class="step">
        <div class="item" :class="{'activeStep' : addform.addStep == 1}">1、编辑名称</div>
        <div class="item" :class="{'activeStep' : addform.addStep == 2}">2、选择设备</div>
        <div class="item" :class="{'activeStep' : addform.addStep == 3}">3、设置审批</div>
      </div>
      <template v-if="addform.addStep == 1">
      <div class="contDio minH300">
        <div class="tips tc"><p>为新建会议室命名</p><p>以根据名称区别不同的会议室</p></div>
        <el-input class="mb20" placeholder="请输入会议室名称" v-model="addform.projectName"></el-input>
        <el-input placeholder="请输入会议室地址" v-model="addform.projectUrl"></el-input>
      </div>
      <span slot="footer">
        <el-button @click="addDio = false">取 消</el-button>
        <el-button type="primary" @click="nextStep">下一步</el-button>
      </span>
      </template>
      <template v-else-if="addform.addStep == 2">
      <div class="contDio minH300">
        <div class="tips tc"><p>选择会议室包含的设备</p><p>用户预约成功后，将获得这些设备的使用权限</p></div>
        
        <p class="conDoor">会议室门禁:</p>
        <el-select class="doorSel" v-model="addform.accessDeviceNoId" filterable  placeholder="选择门禁设备" style="width:560px">
          <el-option
          v-for="item in deviceList"
          :key="item.device_no_id"
          :label="item.device_no_id + ' - ' + item.device_name"
          :value="item.device_no_id">
          </el-option>
        </el-select><br>

        <p class="conDoor">会议室电表:</p>
        <el-select class="doorSel" v-model="addform.emeterDeviceNoId" filterable  placeholder="选择电表设备"  style="width:560px">
          <el-option
          v-for="item in ammetersList"
          :key="item.device_no_id"
          :label="item.device_no_id + ' - ' + item.device_name"
          :value="item.device_no_id">
          </el-option>
        </el-select>
       
        <div class="tit flex">
          <div>默认叠加门禁：</div>
          <div class="col6">已选择：{{addform.device_id.length}}项</div>
        </div>
        <div class="authUserList flex">
          <div class="userTree">
            <div class="titSub">空间列表</div>
            <el-tree
            ref="tree"
            class="defineTree"
            :data="spaceList"
            highlight-current
            default-expand-all
            node-key="space_id"
            :expand-on-click-node="false"
            :props="treeProps"
            @node-click="getNode">
              <span class="custom-tree-node" slot-scope="{ node,data }">
                <i
                  class="defineIcon"
                  :class="{ 'el-icon-plus': !node.expanded, 'el-icon-minus':node.expanded, opacity: node.childNodes.length === 0}">
                </i>
                <span class="label" :class="data.space_id === addform.space_id ? 'selectedTree' : ''">{{ node.label }}</span>
              </span>
            </el-tree>
          </div>
          <div class="checkList">
            <div class="titSub">设备列表</div>
            <div class="search">
              <el-input size="small" placeholder="请输入设备ID或设备名称" prefix-icon="el-icon-search" v-model="addform.search" @input="searchInput"></el-input>
            </div>
            <el-checkbox class="dblock" :indeterminate="addform.isIndeterminate" v-model="addform.checkAll" @change="CheckAllChange">全选</el-checkbox>

            <el-checkbox-group class="groupH" v-model="addform.device_id" @change="CheckedItemChange">
              <el-checkbox :disabled="(item.device_no_id == addform.accessDeviceNoId)"  :class="{dblock:true, hide:(item.device_no_id == addform.accessDeviceNoId)}" v-for="(item,index) in deviceList" :label="item.device_no_id" :key="index">{{item.device_no_id}}-{{item.device_name}}</el-checkbox>
            </el-checkbox-group>

          </div>
        </div>
        <!-- 红外传感设置 -->
        <div class="redSetting" v-if="addform.isShowRedSetting">
          <p class="tit">已关联带有红外传感的门禁</p>
          <div class="des">
            <el-checkbox v-model="addform.redSettingTimer">设置定时任务</el-checkbox>
            <div>
              <span>当</span> 
              <el-input-number v-model="addform.timer" controls-position="right" @change="handleChange" :min="1"></el-input-number>
              <span>分钟内检测到无人，则关闭该会议室所有电表</span>
            </div>
          </div>
        </div>
      </div>
      <span slot="footer">
        <el-button type="primary" @click="prevStep">上一步</el-button>
        <el-button type="primary" @click="nextStep">下一步</el-button>
      </span>
      </template>
      <template v-else>
      <div class="contDio minH300">
        <div class="tips tc"><p>设置审批人，则用户提交预约后</p><p>需要审批人或在后台通过审批方可获得授权</p></div>
        <el-checkbox v-model="addform.isCheck" @change="addform.userName='';addform.user_id=''">设置审批人（如不勾选则只需被访人审批）</el-checkbox>
        <div class="tit flex">
          <div>设置审批人：{{addform.userName}}</div>
        </div>
        <div class="authUserList flex" v-if="addform.isCheck">
          <div class="userTree">
            <div class="titSub">部门列表</div>
            <el-tree
            ref="tree"
            class="defineTree"
            :data="deparList"
            highlight-current
            default-expand-all
            node-key="id"
            :expand-on-click-node="false"
            :props="selectProps"
            @node-click="getNode2">
              <span class="custom-tree-node" slot-scope="{ node,data }">
                <i
                  class="defineIcon"
                  :class="{ 'el-icon-plus': !node.expanded, 'el-icon-minus':node.expanded, opacity: node.childNodes.length === 0}">
                </i>
                <span class="label" :class="data.id === addform.depart_id ? 'selectedTree' : ''">{{ node.label }}</span>
              </span>
            </el-tree>
          </div>
          <div class="checkList">
            <div class="titSub">人员列表</div>
            <div class="search pdtb6">
              <el-input size="small" placeholder="请输入姓名或手机号码" prefix-icon="el-icon-search" v-model="addform.search2" @input="searchUser"></el-input>
            </div>
            <el-radio-group class="groupH" v-model="addform.user_id" @change="getuserName">
              <el-radio class="dblock" v-for="(item,index) in auditorList" :label="item.user_id" :key="index">{{item.user_name}}-{{item.phone_no}}</el-radio>
            </el-radio-group>
          </div>
        </div>
        
      </div>
      <span slot="footer">
        <el-button type="primary" @click="prevStep">上一步</el-button>
        <el-button type="primary" @click="submitConfig()">保存项目</el-button>
      </span>
      </template>
    </el-dialog>

    <!--修改弹窗-->
    <el-dialog title="修改会议室预约" :visible.sync="editDio" width="700px" class="configDio accessDio" center>
      <div class="step">
        <div class="item" :class="{'activeStep' : editform.addStep == 1}">1、编辑名称</div>
        <div class="item" :class="{'activeStep' : editform.addStep == 2}">2、选择设备</div>
        <div class="item" :class="{'activeStep' : editform.addStep == 3}">3、设置审批</div>
      </div>
      <template v-if="editform.addStep == 1">
      <div class="contDio minH300">
        <div class="tips tc"><p>为新建会议室命名</p><p>以根据名称区别不同的会议室</p></div>
        <el-input class="mb20" placeholder="请输入会议室名称" v-model="editform.projectName"></el-input>
        <el-input placeholder="请输入会议室地址" v-model="editform.projectUrl"></el-input>
      </div>
      <span slot="footer">
        <el-button @click="editDio = false">取 消</el-button>
        <el-button type="primary" @click="nextStep">下一步</el-button>
      </span>
      </template>
      <template v-else-if="editform.addStep == 2">
      <div class="contDio minH300">
        <div class="tips tc"><p>选择会议室包含的设备</p><p>用户预约成功后，将获得这些设备的使用权限</p></div>

        <p class="conDoor">会议室门禁:</p>
        <el-select class="doorSel" v-model="editform.accessDeviceNoId" filterable  placeholder="无" style="width:560px">
          <el-option
          v-for="item in deviceList"
          :key="item.device_no_id"
          :label="item.device_no_id + ' - ' + item.device_name"
          :value="item.device_no_id">
          </el-option>
        </el-select><br>

        <p class="conDoor">会议室电表:</p>
        <el-select class="doorSel" v-model="editform.emeterDeviceNoId" filterable  placeholder="无"  style="width:560px">
          <el-option
          v-for="item in ammetersList"
          :key="item.device_no_id"
          :label="item.device_no_id + ' - ' + item.device_name"
          :value="item.device_no_id">
          </el-option>
        </el-select>
        
        <div class="tit flex">
          <div>默认叠加门禁：</div>
          <div class="col6">已选择：{{editform.device_id.length}}项</div>
        </div>
        <div class="authUserList flex">
          <div class="userTree">
            <div class="titSub">空间列表</div>
            <el-tree
            ref="tree"
            class="defineTree"
            :data="spaceList"
            highlight-current
            default-expand-all
            node-key="space_id"
            :expand-on-click-node="false"
            :props="treeProps"
            @node-click="getNode3">
              <span class="custom-tree-node" slot-scope="{ node,data }">
                <i
                  class="defineIcon"
                  :class="{ 'el-icon-plus': !node.expanded, 'el-icon-minus':node.expanded, opacity: node.childNodes.length === 0}">
                </i>
                <span class="label" :class="data.space_id === editform.space_id ? 'selectedTree' : ''">{{ node.label }}</span>
              </span>
            </el-tree>
          </div>
          <div class="checkList">
            <div class="titSub">设备列表</div>
            <div class="search">
              <el-input size="small" placeholder="请输入设备ID或设备名称" prefix-icon="el-icon-search" v-model="editform.search" @input="searchInput2"></el-input>
            </div>
            <el-checkbox class="dblock" :indeterminate="editform.isIndeterminate" v-model="editform.checkAll" @change="CheckAllChange2">全选</el-checkbox>
            <el-checkbox-group class="groupH" v-model="editform.device_id" @change="CheckedItemChange2">
              <el-checkbox :disabled="(item.device_no_id == editform.accessDeviceNoId)" :class="{dblock:true, hide:(item.device_no_id == editform.accessDeviceNoId)}" v-for="(item,index) in deviceList" :label="item.device_no_id" :key="index">{{item.device_no_id}}-{{item.device_name}}</el-checkbox>
            </el-checkbox-group>
          </div>
        </div>
        <!-- 红外传感设置 -->
        <div class="redSetting" v-if="editform.isShowRedSetting">
          <p class="tit">已关联带有红外传感的门禁</p>
          <div class="des">
            <el-checkbox v-model="editform.redSettingTimer">设置定时任务</el-checkbox>
            <div>
              <span>当</span> 
              <el-input-number v-model="editform.timer" controls-position="right" @change="handleChange" :min="1"></el-input-number>
              <span>分钟内检测到无人，则关闭该会议室所有电表</span>
            </div>
          </div>
        </div>
      </div>
      <span slot="footer">
        <el-button type="primary" @click="prevStep">上一步</el-button>
        <el-button type="primary" @click="nextStep">下一步</el-button>
      </span>
      </template>
      <template v-else>
      <div class="contDio minH300">
        <div class="tips tc"><p>设置审批人，则用户提交预约后</p><p>需要审批人或在后台通过审批方可获得授权</p></div>
        <el-checkbox v-model="editform.isCheck" @change="editform.userName='';editform.user_id=''">设置审批人（如不勾选则只需被访人审批）</el-checkbox>
        <div class="tit flex">
          <div>设置审批人：{{editform.userName}}</div>
        </div>
        <div class="authUserList flex" v-if="editform.isCheck">
          <div class="userTree">
            <div class="titSub">部门列表</div>
            <el-tree
            class="defineTree"
            :data="deparList"
            highlight-current
            default-expand-all
            node-key="id"
            :expand-on-click-node="false"
            :props="selectProps"
            @node-click="getNode4">
              <span class="custom-tree-node" slot-scope="{ node,data }">
                <i
                  class="defineIcon"
                  :class="{ 'el-icon-plus': !node.expanded, 'el-icon-minus':node.expanded, opacity: node.childNodes.length === 0}">
                </i>
                <span class="label" :class="data.id === editform.depart_id ? 'selectedTree' : ''">{{ data.name }}</span>
              </span>
            </el-tree>
          </div>
          <div class="checkList">
            <div class="titSub">人员列表</div>
            <div class="search pdtb6">
              <el-input size="small" placeholder="请输入姓名或手机号码" prefix-icon="el-icon-search" v-model="editform.search2" @input="searchUser2"></el-input>
            </div>
            <el-radio-group class="groupH" v-model="editform.user_id" @change="getuserName2">
              <el-radio class="dblock" v-for="(item,index) in auditorList" :label="item.user_id" :key="index">{{item.user_name}}-{{item.phone_no}}</el-radio>
            </el-radio-group>
          </div>
        </div>
        
      </div>
      <span slot="footer">
        <el-button type="primary" @click="prevStep">上一步</el-button>
        <el-button type="primary" @click="submitConfig(editform.id)">保存项目</el-button>
      </span>
      </template>
    </el-dialog>

    <!--查看包含设备-->
    <el-dialog title="包含设备" :visible.sync="accessDeviceDio" width="700px">
      <div class="contDio">
        <div class="tabList">
          <el-table :data="accessDevice" style="width: 100%">
            <el-table-column label="序号" type="index"></el-table-column>
            <el-table-column label="设备ID" prop="device_no_id"></el-table-column>
            <el-table-column label="设备类型" prop="device_type"></el-table-column>
            <el-table-column label="设备名称" prop="device_name"></el-table-column>
          </el-table>
        </div>
      </div>
    </el-dialog>

    <!--预览二维码-->
    <el-dialog title="" :visible.sync="previewDio" class="previewDio" width="350px">
      <div class="tr"><el-button v-print="'#ewm'">打印</el-button></div>
      <div class="img" id="ewm"><img :src="dioImageUrl" alt=""></div>
    </el-dialog>

    <!--删除配置-->
    <el-dialog title="" :visible.sync="statusDio" class="statusDio">
      <div class="statusCont">
        <div>是否删除该配置？</div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="statusDio = false">取 消</el-button>
        <el-button type="primary" @click="delConfig">确定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
  import CBreadCrumb from "../Layout/CBreadCrumb.vue"
  import { showToast, localUserInfo } from "../../../../static/js/utility/utility.js"
  import { unmanApi,eSiteApi,sceneApi, bussinessApi,userApi, deviceApi } from "../../../../static/js/api.js"
  import * as _ from 'lodash'

  export default {
    name: 'CConferenceConfig',
    components: {
      CBreadCrumb
    },
    data() {
      return {
        doorsList:[{
          valueDoor:'demo1',
          label:'门禁1'
        },{
          valueDoor:'demo2',
          label:'门禁2'
        }],
        valueDoor:'',

        ammetersList:[],


        configList:[],//配置列表
        tableLoading:false,
        //分页
        curr:1,//当前页
        page:10,//显示个数
        total:0,//总数据

        addDio:false,//新建弹窗
        addform:{
          addStep:1,//步骤
          projectName:'',//项目名称
          projectUrl:'',//项目地址
          isIndeterminate:false,//全选状态
          checkAll:false,//是否全选
          space_id:'',//当前空间id
          search:'',//设备搜索
          device_id:[],
          search2:'',//用户搜索
          userName:'',//审批人
          user_id:'',//选中的用户
          depart_id:'',//部门当前选中
          isCheck:false,//默认不勾选
          isShowRedSetting: false, //是否显示红外传感设置
          redSettingTimer: false, //是否设置红外传感定时任务
          timer: 5,
          emeterDeviceNoId:'', //电表设备ID
          accessDeviceNoId:'',//门禁设备ID
        },

        editDio:false,//修改弹窗
        editform:{
          id:'',//修改的配置ID
          addStep:1,//步骤
          projectName:'',//项目名称
          projectUrl:'',//项目地址
          isIndeterminate:false,//全选状态
          checkAll:false,//是否全选
          space_id:'',//当前空间id
          search:'',//设备搜索
          device_id:[],
          search2:'',//用户搜索
          userName:'',//审批人
          user_id:'',//选中的用户
          depart_id:'',//部门当前选中
          isCheck:false,//默认不勾选
          device_info: [], //当前选中的设备信息
          isShowRedSetting: false, //是否显示红外传感设置
          redSettingTimer: false, //是否设置红外传感定时任务
          timer: 5,

          //电表设备ID
          emeterDeviceNoId:'',
          //门禁设备ID 
          accessDeviceNoId:'',
        },

        spaceList:[],//空间列表
        deviceList:[],//设备列表

        redDeviceList: [], //叠加红外传感门禁id列表

        allDevice:[],//所有设备
        allUser:[],//所有用户
        
        deparList:[],//部门列表
        auditorList:[],//用户列表


        selectProps:{
          label: 'name',
          id: 'id',
          children: 'children'
        },
        treeProps:{
          label: 'space_name',
          id: 'space_id',
          children: 'children'
        },

        //查看包含设备
        accessDeviceDio:false,
        accessDevice:[],

        previewDio:false,//预览二维码
        dioImageUrl:'',//二维码地址
        
        //删除配置
        statusDio:false,
        del_id:'',
      };
    },
    mounted(){

    },
    created: async function () {
      this.getMjConfig();
      this.getSpaceList();
      this.getDepartmentList();
    },
    methods: {
      handleChange(value) {
        console.log(value);
      },

      //打开修改配置弹窗
      openEdit(index){
        console.log('this.configList[index].user_id', this.configList[index])
        if(this.configList[index].user_id != ''){
          this.editform.isCheck = true
        }
        let oneItem= this.configList[index];

        let space_id = this.editform.space_id = this.spaceList[0].space_id
        let depart_id = this.editform.depart_id = this.deparList[0].id
        this.editform.addStep = 1
        this.editform.id = oneItem.id
        this.editform.projectName = oneItem.audit_name
        this.editform.projectUrl = oneItem.address
        this.editform.user_id = oneItem.user_id
        this.editform.userName = oneItem.user_name
        this.editform.device_info = oneItem.device_info
      
        //门禁设备
        this.editform.accessDeviceNoId = oneItem.access_device_no_id;

        //电表设备
        this.editform.emeterDeviceNoId = oneItem.memter_device_no_id;
        

        let arr = []
        for(let i in oneItem.device_info){
          arr.push(oneItem.device_info[i].device_no_id)
        }
        this.editform.device_id = arr
        this.editform.timers = Number(oneItem.timer)
        // console.log('editform.device_id', this.editform.device_id)
        this.getSpaceDeviceYy(space_id)
        this.getUserYy(depart_id,'2')
        this.getEmeterDeviceList()
        this.editDio = true
      },

      //打开删除弹窗
      openStatus(id){
        this.del_id = id
        this.statusDio = true;
      },
      //删除配置
      async delConfig(){
        let that = this;
        let data = {
          'id': that.del_id,//授权用户id
        }
        let res = await bussinessApi.delYuyueConfig(data)
        if (res.meta.code === 200) {
          that.getMjConfig(1)
          that.statusDio = false;
          showToast('删除成功！')
        } else {
          showToast(res.meta.message)
        }
      },
      //查看预约二维码
      async previewImg(id){
        // this.dioImageUrl = img
        // this.previewDio = true
        let vm = this
        let company_ic = localUserInfo.getItem().company_ic
        let company_id = localUserInfo.getItem().company_id
        let data = {
          data:{
            "page": "pages/login/login",
            "scene": company_ic+ "yh" + id
          },
          mode: "getUnlimited",
          type: "yh",
          company_id: company_id
        }

        let res = await deviceApi.previewImg(data)
        if (res.meta.code == 200) {
          vm.previewDio = true
          vm.dioImageUrl = res.data.image_url
        } else {
          showToast(res.meta.message)
        }
      },
      //点击查看包含设备
      getAccessDevice(data){
        this.accessDevice = data
        this.accessDeviceDio = true
      },
      //上一步
      prevStep(){
        let that = this;
        if(this.addDio == true){
          if(that.addform.addStep == 3){
            that.addform.addStep = 2
          }else if(that.addform.addStep == 2){
            that.addform.addStep = 1
          }
        }else if(this.editDio == true){
          if(that.editform.addStep == 3){
            that.editform.addStep = 2
          }else if(that.editform.addStep == 2){
            that.editform.addStep = 1
          }
        }
      },

      //下一步
      nextStep(){
        let that = this
        if(this.addDio == true){
          if(that.addform.addStep == 1){
            if(that.addform.projectName == ''){
              showToast('请输入会议室名称')
              return
            }else if(that.addform.projectName.length > 10){
              showToast('会议室名称不能大于10位')
              return
            }
            if(that.addform.projectUrl.length > 20){
              showToast('会议室地址不能大于20位')
              return
            }
            that.addform.addStep = 2
          } else if (that.addform.addStep == 2){
            if (that.addform.accessDeviceNoId === '') {
              showToast('请选择门禁设备')
              return
            }

            /*
            if (that.addform.emeterDeviceNoId === '') {
              showToast('请选择电表设备')
              return
            }
            */

            /*
            if(that.addform.device_id == ''){
              showToast('请选择叠加门禁设备')
              return
            }
            */

            that.addform.addStep = 3
          }
        }else if(this.editDio == true){
          if(that.editform.addStep == 1){
            if(that.editform.projectName == ''){
              showToast('请输入项目名称')
              return
            }else if(that.editform.projectName.length > 10){
              showToast('项目名称不能大于10位')
              return
            }
            if(that.editform.projectUrl.length > 20){
              showToast('会议室地址不能大于20位')
              return
            }
            that.editform.addStep = 2
          }else if(that.editform.addStep == 2){
            if (that.editform.accessDeviceNoId === '') {
              showToast('请选择门禁设备');
              return
            }
            
            /*
            if (that.editform.emeterDeviceNoId === '') {
              showToast('请选择电表设备');
              return
            }
            */

            /*
            if(that.editform.device_id == '' || that.addform.accessDeviceNoId == ''){
              showToast('请选择设备')
              return
            }
            */
            that.editform.addStep = 3
          }
        }
      },
      //提交配置
      async submitConfig(id){
        let that = this
        let res;
        if(id){
          let timer = that.editform.redSettingTimer && that.editform.isShowRedSetting ? that.editform.timer*60 : 0
          let dataObj = {
            'id': id,
            'timer':  timer, // 叠加红外传感门禁设置的定时时间
            'audit_name': that.editform.projectName,
            'user_id':that.editform.user_id,
            'device_no_id':_.pull(that.editform.device_id, that.editform.emeterDeviceNoId, that.editform.accessDeviceNoId),
            'address':that.editform.projectUrl,
            'code_type':'2',//1为门禁，2为会议室，默认1
            'emeter_device_no_id': that.editform.emeterDeviceNoId,
            'access_device_no_id':that.editform.accessDeviceNoId,
          }
          res = await bussinessApi.updateAppintmentAuditor(dataObj)
        }else{
          // console.log('tie', that.addform.redSettingTimer && that.addform.isShowRedSetting)
          let timer = that.addform.redSettingTimer && that.addform.isShowRedSetting ? that.addform.timer*60 : 0
          let dataObj = {
            'timer':  timer, // 叠加红外传感门禁设置的定时时间
            'audit_name':that.addform.projectName,//预约名称
            'device_no_id':_.pull(that.addform.device_id, that.addform.emeterDeviceNoId, that.addform.accessDeviceNoId),//设备组
            'address':that.addform.projectUrl,
            'code_type':'2',//1为门禁，2为会议室，默认1
            'emeter_device_no_id': that.addform.emeterDeviceNoId,
            'access_device_no_id':that.addform.accessDeviceNoId,
          }
          if(that.addform.isCheck==true){
            if(that.addform.user_id == ''){
              showToast('请选择审批人')
              return
            }
            dataObj.user_id=that.addform.user_id
          }
          // console.log('dateobj', dataObj)
          // return
          res = await bussinessApi.configYuyue(dataObj)
        }

        if (res.meta.code == 200) {
          if(!id){
            that.addform={
              addStep:1,//步骤
              projectName:'',//项目名称
              isIndeterminate:false,//全选状态
              checkAll:false,//是否全选
              space_id:'',//当前空间id
              // sizeCheck:['A','B','C'],//门禁大小
              search:'',//设备搜索
              device_id:[],
              search2:'',//用户搜索
              userName:'',//审批人
              user_id:'',//选中的用户
              depart_id:'',//部门当前选中
              isCheck:false,//默认不勾选
            }
            that.deviceList=[]
            that.auditorList=[]
            that.addDio = false
            that.getMjConfig(1)
            showToast('配置成功！')
          }else{
            that.editform.addStep = 1
            that.editDio = false
            that.getMjConfig()
            showToast('修改成功！')
          }
        }else{
          showToast(res.meta.message)
        }
      },

      //获取空间列表
      async getSpaceList(){
        let that = this
        let res = await sceneApi.space()
        if (res.meta.code === 200) {
          that.spaceList = [...res.data]
          // that.processScene(res.data)
        } else {
          showToast(res.meta.message)
        }
      },
      // 处理位置数据
      processScene(data) {
        let that = this
        if ( data.length !== 0) {
          // 显示某个公司或其下级空间的设备列表
          let list = data
          // 获取所属位置列表
          for (let s in list) {
            let area =  list[s].children
            for (let i in area) {
              let street = area[i].children
              for (let j in street) {
                let company = street[j]
                that.spaceList.push(company)
              }
            }
          }
        }
      },
      //通过空间id获取预约的设备列表
      async getSpaceDeviceYy(space_id){
        let that = this;
        const data = {
          'space_id': space_id,
          // 'level_type': size.join(','),
          // 'code':'ACCESS',
          'code_type':'2',//1门禁，2会议室，默认1
        }
        const res = await bussinessApi.getSpaceDeviceYy(data)
        if(res.meta.code == 200){
          that.allDevice = res.data
          that.deviceList = res.data
          for (let i = 0; i < res.data.length; i++) {
            const item = res.data[i];
            if (item.node == 1) {
              that.redDeviceList.push(item)
            }
          }
          // 修改时
          if (that.editDio) {
            that.editform.isShowRedSetting = that.settingRedTimer(that.editform.device_id)
            that.editform.redSettingTimer = that.editform.isShowRedSetting === true && that.editform.timers != 0 ? true : false
            that.editform.timer = this.editform.timers == 0 ? 5: (this.editform.timers/60)
            // this.configList[index].timer === 0 ? 5 : 
            // that.editform.
            // console.log('device_info', that.editform.device_info)
          }
          console.log('redDeviceList', that.redDeviceList)
        }else{
          showToast(res.meta.message)
        }
      },
      // 获取部门列表
      async getDepartmentList() {
        let that = this
        const res = await userApi.getDepartmentList()
        if (res.meta.code === 200) {
          that.deparList = res.data
        } else {
          showToast(res.meta.message)
        }
      },
      //通过部门获取审批人
      async getUserYy(depart_id,type){
        let that = this
        const data = {
          'perPage':99999,
          'department_id':depart_id
        }
        const res = await userApi.getUserList(data)
        if (res.meta.code === 200) {
          that.allUser = res.data.list
          // that.auditorList = res.data.list
          if(type == '1'){
            that.searchUser()
          }else if(type == '2'){
            that.searchUser2()
          }
        } else {
          showToast(res.meta.message)
        }
      },
      //搜索筛选
      searchUser(){
        let that = this;
        var allUser = this.allUser
        var searchList = []
        for(var i in allUser){
          if(that.addform.search2!=''){
            if(allUser[i].user_name.indexOf(that.addform.search2) != -1 || allUser[i].phone_no.indexOf(that.addform.search2) != -1){
              searchList.push(allUser[i])
            }
          }else{
            searchList = allUser
          }
        }
        // console.log('searchList',searchList)
        this.auditorList = searchList
      },
      //同步当前选中的审批人
      getuserName(val){
        this.addform.userName = this.auditorList.find(item => item.user_id === val)["user_name"];
      },
      //获取树形节点(添加)
      getNode2(node){
        let that = this;
        this.addform.depart_id = node.id
        //调用获取用户的接口
        this.getUserYy(node.id,'1')
        // this.getSpaceDeviceSmzf(this.addform.type,'1',node.id)
      },
      //搜索筛选
      searchInput(){
        let that = this;
        var allDevice = this.allDevice
        var searchList = []
        for(var i in allDevice){
          if(that.addform.search!=''){
            if(allDevice[i].device_name.indexOf(that.addform.search) != -1 || allDevice[i].device_no_id.indexOf(that.addform.search) != -1){
              searchList.push(allDevice[i])
            }
          }else{
            searchList = allDevice
          }
        }
        // console.log('searchList',searchList)
        this.deviceList = searchList
      },
      //全选(添加)
      CheckAllChange(val) {
        var arr = []
        for(var i in this.deviceList){
          arr.push(this.deviceList[i].device_no_id)
        }
        arr = Array.from(new Set(arr))
        this.addform.device_id = val ? arr : [];
        this.addform.isIndeterminate = false;
      },
      //选择多个(添加)
      CheckedItemChange(value) {
        let vm = this
        // console.log('value', value, vm.redDeviceList)
        let checkedCount = value.length;
        vm.addform.checkAll = checkedCount === vm.deviceList.length;
        vm.addform.isIndeterminate = checkedCount > 0 && checkedCount < vm.deviceList.length;
        // console.log('checkedCount', checkedCount)
        // let redDeviceList = vm.redDeviceList
        // // 判断是否选择了叠加红外传感设备
        // vm.addform.isShowRedSetting = false
        // let rev = (n) => {
        //   redDeviceList.forEach(function (item, index) {
        //     if (item === value[n]) { vm.addform.isShowRedSetting = true }
        //     if (n+1 < checkedCount){ rev(n+1) }
        //   })
        // }
        // rev(0)
        // console.log('settingRedTimer', vm.settingRedTimer(value, checkedCount))
        vm.addform.isShowRedSetting = vm.settingRedTimer(value)
      },
      // 设置红外定时任务  value是选中的设备id列表
      settingRedTimer(value){
        let vm = this
        let redDeviceList = [...vm.redDeviceList]
        // 判断是否选择了叠加红外传感设备
        let isShowRedSetting = false
        let rev = (n) => {
          redDeviceList.forEach(function (item, index) {
            if (item.device_no_id === value[n]) { 
              isShowRedSetting = true
            }
            if (n+1 < value.length){ rev(n+1) }
          })
        }
        rev(0)
        console.log('isShowRedSetting', isShowRedSetting)
        return isShowRedSetting
      },
      //获取树形节点(添加)
      getNode(node){
        let that = this;
        this.addform.space_id = node.space_id
        //调用获取设备列表的接口
        this.getSpaceDeviceYy(node.space_id)
        // this.getSpaceDeviceSmzf(this.addform.type,'1',node.space_id,this.addform.sizeCheck)
      },


      //搜索筛选
      searchUser2(){
        let that = this;
        var allUser = this.allUser
        var searchList = []
        for(var i in allUser){
          if(that.editform.search2!=''){
            if(allUser[i].user_name.indexOf(that.editform.search2) != -1 || allUser[i].phone_no.indexOf(that.editform.search2) != -1){
              searchList.push(allUser[i])
            }
          }else{
            searchList = allUser
          }
        }
        // console.log('searchList',searchList)
        this.auditorList = searchList
      },
      //同步当前选中的审批人
      getuserName2(val){
        this.editform.userName = this.auditorList.find(item => item.user_id === val)["user_name"];
      },
      //获取树形节点(修改)
      getNode4(node){
        let that = this;
        this.editform.depart_id = node.id
        //调用获取用户的接口
        this.getUserYy(node.id,'2')
        // this.getSpaceDeviceSmzf(this.addform.type,'1',node.id)
      },
      //搜索筛选
      searchInput2(){
        let that = this;
        var allDevice = this.allDevice
        var searchList = []
        for(var i in allDevice){
          if(that.editform.search!=''){
            if(allDevice[i].device_name.indexOf(that.editform.search) != -1 || allDevice[i].device_no_id.indexOf(that.editform.search) != -1){
              searchList.push(allDevice[i])
            }
          }else{
            searchList = allDevice
          }
        }
        // console.log('searchList',searchList)
        this.deviceList = searchList
      },
      //全选(添加)
      CheckAllChange2(val) {
        var arr = []
        for(var i in this.deviceList){
          arr.push(this.deviceList[i].device_no_id)
        }
        arr = Array.from(new Set(arr))
        this.editform.device_id = val ? arr : [];
        this.editform.isIndeterminate = false;
      },
      //选择多个(添加)
      CheckedItemChange2(value) {
        let checkedCount = value.length;
        this.editform.checkAll = checkedCount === this.deviceList.length;
        this.editform.isIndeterminate = checkedCount > 0 && checkedCount < this.deviceList.length;
      },
      //获取树形节点(添加)
      getNode3(node){
        let that = this;
        this.editform.space_id = node.space_id
        //调用获取设备列表的接口
        this.getSpaceDeviceYy(node.space_id)
        // this.getSpaceDeviceSmzf(this.addform.type,'1',node.space_id,this.addform.sizeCheck)
      },


      //打开新建弹窗
      openAdd(){
        let space_id = this.addform.space_id = this.spaceList[0].space_id
        let depart_id = this.addform.depart_id = this.deparList[0].id
        this.addform.projectName = ''
        this.addform.projectUrl = ''
        this.addform.addStep = 1
        this.addform.emeterDeviceNoId = ''
        this.addform.accessDeviceNoId = ''
        this.getEmeterDeviceList()
        this.getSpaceDeviceYy(space_id)
        this.getUserYy(depart_id,'1')
        this.addDio = true
      },

      //获取配置设置列表
      async getMjConfig(curr,limits){
        let that = this;
        this.tableLoading = true
        const data = {
          'page':curr ? curr : that.curr,//当前页
          'perPage': limits ? limits : that.page,//每页条数
          'code_type':'2',//1门禁 2会议室
        }
        let res = await bussinessApi.auditorLiist(data)
        if(res.meta.code == 200){
          that.configList = res.data.list
          that.total = parseInt(res.data.total)
          that.tableLoading = false
        }else{
          that.tableLoading = false
          showToast(res.meta.message)
        }
      },

      //分页
      CurrentChange(val) {
        this.curr = val
        this.getMjConfig(val)
      },

      //获取电表设备列表
      async getEmeterDeviceList(){
        let that = this;
        this.tableLoading = true
        const data = {
          'device_code': 'ELECTRICMETER'
        }
        let res = await bussinessApi.getAppointmentSpaceDeviceList(data)
        
        if(res.meta.code == 200){
          that.ammetersList = res.data
          that.tableLoading = false
        }else{
          that.tableLoading = false
          showToast(res.meta.message)
        }
      },

    },
    watch: {
      
    }
  }
</script>

<style lang="scss">
.CConferenceConfig{
  .tc{
    text-align: center;
  }
  .minH300{
    min-height: 300px;
  }
  .accessDio{
    .titSub{
      height: 30px;
      padding: 0 10px;
      line-height: 30px;
      background: #E8E8E8;
      color: #333;
      box-sizing: border-box;
    }
    .tips{
      color: #999;
      padding: 15px 0;
    }
    .step{
      padding: 0;
      height: 30px;
      margin: 0 33px 0 18px;
      background: #DADADA;
      border-radius: 0;
      display: flex;
      justify-content: center;
      align-items: center;
      .item{
        width: 33.33%;
        font-size: 12px;
        color: #fff;
        line-height: 30px;
        text-align: center;
        position: relative;
        &::after{
          content: "";
          position: absolute;
          right: -30px;
          top: 0;
          width: 0;
          height: 0;
          border-width: 15px;
          border-style: solid;
          border-color: transparent transparent transparent #DADADA;
          z-index: 10;
        }
        &.activeStep{
          background: #4BABFE;
          &::after{
            border-color: transparent transparent transparent #4BABFE;
          }
        }
      }
    }
  }
  .configDio{
    .conDoor{
      display:inline-block;
      margin-bottom: 20px;
      padding-left: 10px;
      padding-bottom: 10px;
      font-size: 14px;
      color: #333;
      
    }
    .doorSel{
      display:inline-block;
      padding-left: 50px;
      
    }
    .selectedTree{
      font-weight: bold;
    }
    .authUserList{
      border: 1px solid #979797;
      align-items: flex-start !important;
      .userTree{
        width: 44%;
        height: 330px;
        overflow-y: auto;
        border-right: 1px solid #979797;
        flex-shrink: 0;
      }
      .checkList{
        flex-grow: 1;
        .search{
          // text-align: center;
          padding: 6px 0 0;
          display: flex;
          justify-content: center;
          align-items: center;
          .el-input{
            width: 50%;
            .el-input__inner{
              border-radius: 16px;
            }
          }
          .sizeDiv{
            margin-left: 10px;
            .el-checkbox{
              margin-right: 10px;
            }
          }
          &.pdtb6{
            padding: 6px 0;
          }
        }
        .el-checkbox.dblock,.el-radio.dblock{
          display: flex;
          justify-content: space-between;
          margin: 8px 0;
          flex-direction: row-reverse;
          padding-right: 16px;
          .el-checkbox__label,.el-radio__label{
            padding-left:16px;
          }
        }
        .el-checkbox-group.groupH{
          height: 227px;
          overflow-y: auto;
          border-top: 1px solid #eee;
        }
        .el-radio-group.groupH{
          display: block;
          height: 256px;
          overflow-y: auto;
          border-top: 1px solid #eee;
        }
      }
    }
    .redSetting{
      padding: 10px;
      border: 1px solid #979797;
      border-top: none;
      .tit {
        padding-left: 0;
        color: #999999;
      }
      .des {
        display: flex;
        align-items: center;
        .el-input-number {
          width: 100px;
          margin: 0 5px;
        }
      }
    }
    .flex{
      display: flex;
      align-items: center;
      justify-content: space-between;
    }
    .tit{
      padding-left: 10px;
      padding-bottom: 10px;
      font-size: 14px;
      color: #333;
    }
    .authUser{
      border:1px solid #e4e7ed;
      align-items: flex-start;
      .userTree{
        width: 200px;
        border-right: 1px solid #e4e7ed;
        height: 300px;
        overflow-y: auto;
      }
      .checkList{
        flex: 1;
        height: 300px;
        overflow-y: auto;
        padding: 20px;
        .el-checkbox-group{
          display: flex;
          flex-wrap: wrap;
          .checkItem{
            width: 33.33%;
            .el-checkbox{ 
              margin-bottom: 10px;
              display: flex;
              align-items: center;
              .el-checkbox__label{
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
              }
            }
          }
        }
        
      }
    }
  }
  .previewDio{
    .tr{
      text-align: right;
      el-button{
        display: inline-block;
        line-height: 1;
        padding: 12px 20px;
        border:1px solid #DCDFE6;
        font-size: 14px;
        color: #606266;
        border-radius: 4px;
      }
    }
    .img{
      width: 200px;
      width: 200px;
      margin: 0px auto;
      padding: 20px;
      img{ width:100%; }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Page/CConference/CConferenceConfig.vue